import router from "@/router";

const Layout = {
  state: () => ({
    hide_anchor_mode_tip_bar: false, // 是否隐藏主播模式的头部提示
    show_dns_tip_bar: false, // 是否展示HTTP DNS横幅提示
    showAddFriendModal: false, // 添加好友弹窗
    showGlobalConfig: false, // 全局设置弹窗
    is_inited_right_bar: {
      team: false,
      search: false,
    }, // 是否已经初始化右侧边栏
    right_bar_module: '', // 右侧边栏模块名 team / search / link / group
    last_show_friend_sidebar: true, // 上一次展示好友侧边栏
    show_friend_sidebar: false, // 是否展示好友侧边栏
    active_sidebar_tab: 'friends', //当前好友列表展示内容 friends/room
    last_private_im_width: 450, // 上一次调整的私聊框宽度
    active_dialogs: [], // 当前激活的弹窗
    cur_link: null,
    cur_link_from: {}, // 当前帖子来源，channel or msg
    active_user_card: '', // 当前激活的用户卡片
    mini_programs: [], // 小程序列表
    sys_anc: null, // 系统通告信息
    miniprogram_setting: [], // 打开的小程序列表

    show_audio_im: false, // 是否展示新语音频道IM
    audio_im_need_scroll_to_bottom: false, // 是否需要滑动到最底部
    show_bgm_selector: false, // 伴奏选择器

    host_mode_height: 360, // 主持人模式组件高度
    host_mode_screen_share_occupy_width: 286, // 主持人模式屏幕共享占位宽度
    host_mode_screen_share_occupy_height: 146, // 主持人模式屏幕共享占位高度
    host_mode_screen_share_occupy_left: 24, // 主持人模式屏幕共享占位左边距

    team_block_height: 360, // 组队块高度

    group_more_init_setting: {}, // 群聊更多初始化设置
    
    init_net_error: false, // 初始化时网络失败
    popover_show: false, // 是否展示popover
  }),
  getters: {
    hide_anchor_mode_tip_bar: (state) => state.hide_anchor_mode_tip_bar,
    show_dns_tip_bar: (state) => state.show_dns_tip_bar,
    showAddFriendModal: (state) => state.showAddFriendModal,
    showGlobalConfig: (state) => state.showGlobalConfig,
    show_right_bar_anmation: (state) => state.show_right_bar_anmation,
    is_inited_right_bar: (state) => state.is_inited_right_bar,
    right_bar_module:(state) => state.right_bar_module,
    show_friend_sidebar: (state) => state.show_friend_sidebar,
    active_sidebar_tab: (state) => state.active_sidebar_tab,
    last_private_im_width: (state) => state.last_private_im_width,
    active_dialogs: (state) => state.active_dialogs,
    cur_link: (state) => state.cur_link,
    cur_link_from: (state) => state.cur_link_from,
    active_user_card: (state) => state.active_user_card,
    mini_programs: (state) => state.mini_programs,
    sys_anc: (state) => state.sys_anc,
    miniprogram_setting: (state) => state.miniprogram_setting,
    show_audio_im: (state) => state.show_audio_im,
    audio_im_need_scroll_to_bottom: (state) => state.audio_im_need_scroll_to_bottom,
    last_show_friend_sidebar: (state) => state.last_show_friend_sidebar,
    show_bgm_selector: (state) => state.show_bgm_selector,
    host_mode_height: (state) => state.host_mode_height,
    host_mode_screen_share_occupy_width: (state) => state.host_mode_screen_share_occupy_width,
    host_mode_screen_share_occupy_height: (state) => state.host_mode_screen_share_occupy_height,
    host_mode_screen_share_occupy_left: (state) => state.host_mode_screen_share_occupy_left,
    team_block_height: (state) => state.team_block_height,
    group_more_init_setting: (state) => state.group_more_init_setting,
    init_net_error: (state) => state.init_net_error,
    popover_show: (state) => state.popover_show,
  },
  mutations: {
    SET_HIDE_ANCHOR_MODE_TIP_BAR(state, val) {
      state.hide_anchor_mode_tip_bar = val
    },
    SET_SHOW_DNS_TIP_BAR(state, val) {
      state.show_dns_tip_bar = val
    },
    SET_ADD_FRIEND_MODAL (state, val) {
      console.log('SET_ADD_FRIEND_MODAL', val);
      state.showAddFriendModal = val
    },
    SET_SHOW_GLOBAL_CONFIG (state, val) {
      state.showGlobalConfig = val
    },
    SET_IS_INITED_RIGHT_BAR (state, val) {
      state.is_inited_right_bar = {
        ...state.is_inited_right_bar,
        ...val
      }
    },

    SET_RIGHT_BAR_MODULE (state, moduleName) {
      const last_right_bar_module = state.right_bar_module
      state.right_bar_module = moduleName
      let show_anmation = true
      if (moduleName) {
        if (last_right_bar_module) {
          show_anmation = false
        }
        if (state.show_friend_sidebar) {
          state.last_show_friend_sidebar = true
          state.show_friend_sidebar = false
          show_anmation = false
        }
      } else {
        if (state.last_show_friend_sidebar) {
          state.show_friend_sidebar = true
          show_anmation = false
        }
      }
      state.show_right_bar_anmation = show_anmation
    },
    SET_SHOW_FRIEND_SIDEBAR(state, val) {
      let show_anmation = true
      let origin_right_bar_module = state.right_bar_module
      if (state.right_bar_module) {
        state.right_bar_module = ''
        show_anmation = false
      }
      if (!val) {
        state.last_show_friend_sidebar = false
      } else {
        state.show_audio_im = false
      }
      // console.trace('SET_SHOW_FRIEND_SIDEBAR', val)
      state.show_friend_sidebar = val
      state.show_right_bar_anmation = show_anmation
    },
    
    SET_ACTIVE_SIDEBAR_TAB(state, val) {
      state.active_sidebar_tab = val
    },
    SET_LAST_PRIVATE_IM_WIDTH(state, val) {
      state.last_private_im_width = val
    },
    SET_CUR_LINK (state, link) {
      state.cur_link = link
    },
    SET_CUR_LINK_FROM (state, val) {
      state.cur_link_from = val
    },
    SET_ACTIVE_USER_CARD (state, val) {
      state.active_user_card = val
    },
    SET_MINI_PROGRAMS (state, val) {
      state.mini_programs = val
    },
    SET_SYS_ANC (state, val) {
      state.sys_anc = val
    },
    SET_MINIPROGRAM_SETTING (state, val) {
      state.miniprogram_setting = val
    },
    SET_SHOW_AUDIO_IM (state, val) {
      state.show_audio_im = val
    },
    SET_AUDIO_IM_NEED_SCROLL_TO_BOTTOM (state, val) {
      state.audio_im_need_scroll_to_bottom = val
    },
    SET_LAST_SHOW_FRIEND_SIDEBAR (state, val) {
      state.last_show_friend_sidebar = val
    },
    SET_SHOW_BGM_SELECTOR (state, val) {
      state.show_bgm_selector = val
    },
    SET_HOST_MODE_HEIGHT (state, val) {
      state.host_mode_height = val
    },
    SET_HOST_MODE_SCREEN_SHARE_OCCUPY_WIDTH (state, val) {
      state.host_mode_screen_share_occupy_width = val
    },
    SET_HOST_MODE_SCREEN_SHARE_OCCUPY_LEFT (state, val) {
      state.host_mode_screen_share_occupy_left = val
    },
    SET_HOST_MODE_SCREEN_SHARE_OCCUPY_HEIGHT (state, val) {
      state.host_mode_screen_share_occupy_height = val
    },
    SET_TEAM_BLOCK_HEIGHT (state, val) {
      state.team_block_height = val
    },
    SET_GROUP_MORE_INIT_SETTING (state, val) {
      state.group_more_init_setting = val
    },
    SET_INIT_NET_ERROR(state, val) {
      state.init_net_error = val
    },
    SET_POPOVER_SHOW(state, val) {
      state.popover_show = val
    },
  },
  actions: {
    SET_SHOW_RIGHT_BAR_MODULE ({ commit, state }, moduleName) {
      if (moduleName === 'team') {
        if (!state.is_inited_right_bar.team) {
          import('@/views/room/Team/index.vue').then(module => {
            commit('SET_RIGHT_BAR_MODULE', 'team')
            commit('SET_IS_INITED_RIGHT_BAR', {
              team: true
            })
          })
        } else {
          commit('SET_RIGHT_BAR_MODULE', 'team')
        }
      } else if (moduleName === 'search') {
        if (!state.is_inited_right_bar.search) {
          import('@/layout/components/channel-search/index.vue').then(module => {
            commit('SET_RIGHT_BAR_MODULE', 'search')
            commit('SET_IS_INITED_RIGHT_BAR', {
              search: true
            })
          })
        } else {
          commit('SET_RIGHT_BAR_MODULE', 'search')
        }
      } else {
        commit('SET_RIGHT_BAR_MODULE', moduleName)
      }

      if (moduleName) {
        commit('SET_SHOW_AUDIO_IM', false)
        if(['link', 'reply'].includes(moduleName) && router.currentRoute.name !== 'friends') {
          commit('SET_CUR_PRIVATE_USER', {})
        }
      }
    },
    SET_SHOW_AUDIO_IM_ACTION ({ commit, state }, val) {
      commit('SET_SHOW_AUDIO_IM', val)
      
      if(val) {
        // 将右边栏模块设置为空
        commit('SET_RIGHT_BAR_MODULE', '')
        // 将好友侧边栏设置为false
        commit('SET_SHOW_FRIEND_SIDEBAR', false)
      }
    },
  }
}
export default Layout